import React, { useCallback, useEffect, useState } from 'react'
import './accounts.css'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import DashboardService from '../../services/dashboard.service'
import { ACCOUNT_SUB_MENUS } from '../../api/menu-details'
import { getAccountListSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'
import { ACCOUNTS_MENU_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function Accounts() {
  const history = useHistory()
  const [subMenuList, setSubMenuList] = useState([])
  const accounts = useSelector(getAccountListSelector) || []
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['ACCOUNTS'] || {}

  useEffect(() => {
    getSubMenus()
    return () => {}
  }, [])

  const getSubMenus = useCallback(async () => {
    try {
      const response = await DashboardService.getAccountSubMenus()
      if (response.status === 200) {
        console.log(response.data)
        setSubMenuList(response.data)
      }
    } catch (err) {}
  }, [])

  return (
    <LayoutWithAccountCard breadCumKey='ACCOUNTS'>
      <Row>
        <Col
          xs={'auto'}
          sm={'auto'}
          md={'auto'}
          className='account-menu-card'
          onClick={() => (accounts.length > 0 ? history.push('/statement') : '')}>
          <img width={46} height={40} src={ACCOUNT_SUB_MENUS.ICONS['STATEMENTS']} />
          <h2>{t(ACCOUNTS_MENU_KEYS.STATEMENT)}</h2>
          <span>{t(ACCOUNTS_MENU_KEYS.STATEMENT_DESCRIPTION)}</span>
        </Col>

        {subMenuList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() => (accounts.length > 0 ? history.push(ACCOUNT_SUB_MENUS.LINKS[option?.screenCode]) : '')}>
            <img width={46} height={40} src={ACCOUNT_SUB_MENUS.ICONS[option?.screenCode]} />
            {/* <h2>{option.title}</h2> */}
            <h2>{t(`${ACCOUNT_SUB_MENUS.TITLE[option?.screenCode]}`)}</h2>
            <span>{t(`${ACCOUNT_SUB_MENUS.DESCRIPTION[option?.screenCode]}`)}</span>
          </Col>
        ))}
        {menuConfig['SET_ACCOUNT_NAME'] &&(<Col
          xs={'auto'}
          sm={'auto'}
          md={'auto'}
          className='account-menu-card'
          onClick={() => (accounts.length > 0 ? history.push('/add-accountName') : '')}>
          <img width={46} height={40} src={ACCOUNT_SUB_MENUS.ICONS['SET_ACCOUNT_NAME']} />
          <h2>{t(ACCOUNTS_MENU_KEYS.SET_ACCOUNT_NAME)}</h2>
          <span>{t(ACCOUNTS_MENU_KEYS.SET_ACCOUNT_NAME_DESCRIPTION)}</span>
        </Col>)}
      </Row>
    </LayoutWithAccountCard>
  )
}
